import { render, staticRenderFns } from "./criterion.vue?vue&type=template&id=3566d0ed&"
import script from "./criterion.vue?vue&type=script&lang=js&"
export * from "./criterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports